export default "<div class=\"ng-new-wrapper\">\r\n\t<router-outlet></router-outlet>\r\n</div>";